/*
 Poornima 09/19/2022 2701251212 Fixed GAL-127,132,73,60,104 bugs
 akhila 10/27/2022 2701251212  record format UX Changes
*/
import React, {useState, useEffect, useContext} from 'react';
import {useSelector} from 'react-redux';
import {makeStyles} from '@material-ui/core/styles';
import {useDispatch} from 'react-redux';
import {fetchRecordFormat} from '../../../redux/reducers/BRE/AddRecordFormat';
import Typography from '@material-ui/core/Typography';
import AddRecordFormat from './AddRecordFormat';
import SearchRecordFormat from './SearchRecordFormat';
import EnableRecordFormat from './EnableRecordFormat';
import SelectTabContextProvider from '../../../components/SelectTabContext/SelectTabContext';
import UsageRecordFormat from './UsageRecordFormat';

const useStyles = makeStyles((theme) => ({
  'root': {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  'padding': {
    padding: '40px',
  },
  'MuiTabScrollButton-root': {
    color: 'black',
  },
  'demo1': {
    color: 'white',
    borderRadius: '6px',
  },
  'antRuleButton': {
    margin: '-8px 0 8px',
  },
}));

export default function RuleGroupTabs({recordFormatId, setTabValue}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {editRecordFormatId, setEditRecordFormatId} = useContext(SelectTabContextProvider);
  const [value, setValue] = useState(0);
  const [recordFormatCode, setRecordFormatCode] = useState(null);
  const [fieldListId, setFieldListId] = useState('');
  const [formatType, setFormatType] = useState('RecordFormat');
  const [isCopyIcon, setIsCopyIcon] = useState(false);
  const [roleDataFormat, setRoleDataFormat] = useState({});
  const {roleData} = useSelector(({role}) => role);
  const [notesEnable, setNotesEnable] = useState('');
  const [rowSelected, setRowSelected] = useState(false);
  useEffect(() => {
    if (editRecordFormatId) {
      setValue(1);
      dispatch(fetchRecordFormat(editRecordFormatId));
      setEditRecordFormatId(null);
    }
  }, []);
  useEffect(() => {
    setRoleDataFormat(roleData ? roleData?.window?.['Record Format']?.RF : {});
  }, [roleData]);
  return (
    <div className={classes.root}>
      <div className={classes.antRuleButton}>
        <Typography />
      </div>
      <div className={classes.subContent}>
        {value === 0 ? (
          <SearchRecordFormat
            setRecordFormatCode={setRecordFormatCode}
            setValue={setValue}
            formatType={formatType}
            setFormatType={setFormatType}
            fieldListId={fieldListId}
            setFieldListId={setFieldListId}
            setIsCopyIcon={setIsCopyIcon}
            isCopyIcon={isCopyIcon}
            setNotesEnable={setNotesEnable}
            setRowSelected={setRowSelected}
          />
        ) :
          value === 1 ? (
            <AddRecordFormat
              roleDataFormat={roleDataFormat}
              setRecordFormatCode={setRecordFormatCode}
              recordFormatCode={recordFormatCode}
              setValue={setValue}
              setTabValue={setTabValue}
              fieldListId={fieldListId}
              setFieldListId={setFieldListId}
              isCopyIcon={isCopyIcon}
              notesEnable={notesEnable}
              rowSelected={rowSelected}
            />
          ) :
            value === 2 ? (
              <EnableRecordFormat
                roleDataFormat={roleDataFormat}
                setRecordFormatCode={setRecordFormatCode}
                recordFormatCode={recordFormatCode}
                setValue={setValue}
                setTabValue={setTabValue}
                setFormatType={setFormatType}
                isCopyIcon={isCopyIcon}
                setFieldListId={setFieldListId}
                notesEnable={notesEnable}
              />
            ) :
              null}
        {value === 3 && <UsageRecordFormat setValue={setValue} />}
      </div>
    </div>
  );
}
